/*

=========================================================
* Now UI Kit React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/now-ui-kit-react
* Copyright 2019 Creative Tim (http://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/now-ui-kit-react/blob/master/LICENSE.md)

* Designed by www.invisionapp.com Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

// styles for this kit
import "assets/css/bootstrap.min.css";
import "assets/scss/now-ui-kit.scss";
import "assets/demo/demo.css";
import "assets/demo/nucleo-icons-page-styles.css";
// pages for this kit
import Index from "views/Index.js";
import Index2 from "views/Index2.js";
import NucleoIcons from "views/NucleoIcons.js";
import LoginPage from "views/examples/LoginPage.js";
import LogoutPage from "views/Logout.js";
import LandingPage from "views/examples/LandingPage.js";
import LineLiff from "views/LineLiff";
import LineRegister from "./views/LineRegister";
import LineThaiD from "./views/LineThaiD";
import Register from "views/Register";
import ChildRegister from "views/ChildRegister";
import ChildRegister1 from "views/ChildRegister1";
import Info from "views/Info";
import Profile from "views/Profile";
import ProfileNetwork from "views/ProfileNetwork";
import TelePage from "views/TelePage";
import ConsultPage from "views/ConsultPage";
import TeleInfo from "views/TeleInfo";
import ConsultInfo from "views/ConsultInfo";
import BookingPage from "views/BookingPage";
import Home from "views/Home";
import Visit from "views/Visit";
import Vaccine from "views/Vaccine";
import Vaccine2 from "views/Vaccine2";
import Vaccine2Admin from "views/Vaccine2Admin";
import VaccineMahidol2 from "views/VaccineMahidol2";
import VaccineWalkin from "views/VaccineWalkin";
import VaccinePfizer from "views/VaccinePfizer";
import VaccineClose from "views/VaccineClose";

import MergeHN from "./views/MergeHN";
import Admin from "./views/Admin";
import NetworkHosp from "./views/NetworkHosp";
import PatientPage from "./views/PatientPage";
import ReportPage from "./views/ReportPage";
import ProfilePage from "views/examples/ProfilePage.js";
import NurseCall from "./views/NurseCall";
import VDOCall from "./views/VDOCall";
import VDOAdmin from "./views/VDOAdmin";
import CameraTest from "./views/CameraTest";
import { authenticationService } from '_services';
import SignPad from "./views/SignPad";
import ConfirmPayment from "./views/ConfirmPayment";
import LineLiffQuery from "./views/LineLiffQuery";
import LineRegister2 from "./views/LineRegister2";
import FullImage from "./views/FullImage";
import PatientImage from "./views/PatientImage";


import SI from "./views/SI";
import VaccineStudent from "./views/VaccineStudent";
import VaccineStudent2 from "./views/VaccineStudent2";
import VaccinePfizerQueue from "views/VaccinePfizerQueue";
import VaccinePfizerQueue2 from "views/VaccinePfizerQueue2";
import VaccineAdmin from "views/VaccineAdmin";
import JitsiVDO from "./views/JitsiVDO";
import PHR from "views/PHR";
import CCNote from "views/CCNote";
import ICD10 from "views/ICD10";

ReactDOM.render(

  <BrowserRouter>
    <Switch>
            <Switch>
                <Route path="/index" render={props => <LoginPage {...props} />} />
                <Route path="/lineliff/:redirect" render={props => <LineLiff {...props} />} />
                <Route path="/lineliff" render={props => <LineLiff {...props} />} />

                <Route path="/lineliff2/lineliff2" render={props => <LineLiffQuery {...props} />} />
                <Route path="/lineliff2" render={props => <LineLiffQuery {...props} />} />

                <Route path="/hn/hn" render={props => <MergeHN {...props} />} />
                <Route path="/hn" render={props => <MergeHN {...props} />} />

                <Route path="/register" render={props => <Register {...props} />} />

                <Route path="/lineregister/:liffId" render={props => <LineRegister {...props} />} />
                <Route path="/lineregister" render={props => <LineRegister {...props} />} />
                <Route path="/linethaid" render={props => <LineThaiD {...props} />} />
                <Route path="/lineregister2/:liffId" render={props => <LineRegister2 {...props} />} />
                <Route path="/lineregister2" render={props => <LineRegister2 {...props} />} />


                <Route path="/tele" render={props => <TelePage {...props} />} />
                <Route path="/tele2" render={props => <TelePage {...props} />} />

                <Route path="/patientimage" render={props => <PatientImage {...props} />} />

                
                <Route path="/consult/:userID" render={props => <ConsultPage {...props} />} />
                <Route path="/images/:fileID" render={props => <FullImage {...props} />} />


                <Route path="/booking" render={props => <BookingPage {...props} />} />
                <Route path="/softconimg/:DocDT" render={props => <SI {...props} />} />
                
                <Route path="/payment/:teleID" render={props => <ConfirmPayment {...props} />} />
                <Route path="/teleInfo/:teleID" render={props => <TeleInfo {...props} />} />

                <Route path="/consultinfo/:teleID" render={props => <ConsultInfo {...props} />} />

                <Route path="/home" render={props => <Home {...props} />} />

                <Route path="/visit/:ServiceType" render={props => <Visit {...props} />} />
                <Route path="/visit" render={props => <Visit {...props} />} />
                <Route path="/vaccine/:cid" render={props => <Vaccine {...props} />} />
                <Route path="/vaccine" render={props => <Vaccine {...props} />} />

                <Route path="/vaccinebooking2/:role" render={props => <VaccinePfizer {...props} />} />
                <Route path="/vaccinebooking2" render={props => <VaccinePfizer {...props} />} />
                <Route path="/vaccinebooking" render={props => <VaccinePfizer {...props} />} />
                <Route path="/PHR" render={props => <PHR {...props} />} />
                //<Route path="/ccnote/:serviceUnitKey/:startDate/:endDate/:json" render={props => <CCNote {...props} />} />
                <Route path="/ccnote/:serviceUnitKey/:startDate/:endDate" render={props => <CCNote {...props} />} />
                <Route path="/icd10/:serviceUnitKey/:startDate/:endDate" render={props => <ICD10 {...props} />} />
                {/*
                 * <Route path="/vaccinebooking" render={props => <VaccinePfizer {...props} />} />
                */}
            

                <Route path="/vaccineadmin/:cid" render={props => <VaccineAdmin {...props} />} />
                <Route path="/vaccineadmin/" render={props => <VaccineAdmin {...props} />} />


                <Route path="/vaccinequeue/:cid" render={props => <VaccinePfizerQueue2 {...props} />} />
                <Route path="/vaccinequeue/" render={props => <VaccinePfizerQueue2 {...props} />} />
                {/*
                 * 
                 * 
                <Route path="/pfizer" render={props => <VaccinePfizer {...props} />} />
                <Route path="/pfizerqueue/:cid" render={props => <VaccinePfizerQueue {...props} />} />
                <Route path="/pfizerqueue/" render={props => <VaccinePfizerQueue {...props} />} />


                 <Route path="/mahidol" render={props => <VaccineMahidol2 {...props} />} />


                <Route path="/vaccineregister" render={props => <VaccineWalkin {...props} />} />

                <Route path="/vaccinebooking/:cid" render={props => <Vaccine2 {...props} />} />
                <Route path="/vaccinebooking" render={props => <Vaccine2 {...props} />} />
                <Route path="/vaccineregister" render={props => <VaccineWalkin {...props} />} />

                <Route path="/vaccinebooking/:cid" render={props => <Vaccine2 {...props} />} />
                <Route path="/vaccinebooking" render={props => <Vaccine2 {...props} />} />

                              <Route path="/student" render={props => <VaccinePfizer {...props} />} />
                <Route path="/studentadmin" render={props => <VaccineStudent2 {...props} />} />
                */}

                
  
                <Route path="/admin/:ServiceType" render={props => <Admin {...props} />} /> 
                <Route path="/admin" render={props => <Admin {...props} />} /> 

                <Route path="/patient" render={props => <PatientPage {...props} />} />

                <Route path="/hospital/patient" render={props => <PatientPage {...props} />} />
                <Route path="/hospital/report" render={props => <ReportPage {...props} />} />
                <Route path="/hospital/register1" render={props => <ChildRegister {...props} />} />
                <Route path="/hospital/register" render={props => <ChildRegister1 {...props} />} />

                <Route path="/hospital" render={props => <NetworkHosp {...props} />} />

                <Route path="/index2" render={props => <Index2 {...props} />} />
                <Route path="/profile/:liffId" render={props => <Profile {...props} />} />
                <Route path="/profile2/:liffId" render={props => <Info {...props} />} />
                <Route path="/profile" render={props => <Profile {...props} />} />
                <Route path="/user/:Id" render={props => <Profile {...props} />} />
                <Route path="/usernetwork/:Id" render={props => <ProfileNetwork {...props} />} />
                <Route path="/user2/:Id" render={props => <Info {...props} />} />
                <Route path="/nursecall" render={props => <NurseCall {...props} />} />

                <Route path="/vdocall/:teleID" render={props => <VDOCall {...props} />} />

                <Route path="/vdocall" render={props => <VDOCall {...props} />} />
                <Route path="/vdoadmin/:teleID" render={props => <VDOAdmin {...props} />} />
                <Route path="/sign" render={props => <SignPad {...props} />} />
                <Route path="/camera/:teleID" render={props => <CameraTest {...props} />} />

                <Route path="/call/:teleID" render={props => <JitsiVDO {...props} />} />


        <Route
          path="/nucleo-icons"
          render={props => <NucleoIcons {...props} />}
        />

        <Route
          path="/landing-page"
          render={props => <LandingPage {...props} />}
        />
        <Route
          path="/profile-page"
          render={props => <ProfilePage {...props} />}
        />
        <Route path="/login" render={props => <LoginPage {...props} />} />
                <Route path="/logout" render={props => <LogoutPage {...props} />} />

                
                <Redirect from="/" to="/login" />
      </Switch>
    </Switch>
  </BrowserRouter>,
  document.getElementById("root")
);
//<Redirect to="/index" /> 